import { Selector } from '@ngxs/store';

import { CheckUserExistsResult } from '../../models';
import { MemberState, MemberStateModel } from '../member.state';

export class MemberSelectors {
  @Selector([MemberSelectors._userExists])
  static isUserExists(userExists: boolean): boolean {
    return userExists;
  }

  @Selector([MemberSelectors._isCheckingUserExistence])
  static isCheckingUserExistence(isCheckingUserExistence: boolean): boolean {
    return isCheckingUserExistence;
  }

  @Selector([MemberSelectors._userExistenceCheckError])
  static userExistenceCheckError(userExistenceCheckError: string): string {
    return userExistenceCheckError;
  }

  @Selector([MemberSelectors._userExistenceCheckCompleted])
  static isUserExistenceCheckCompleted(
    userExistenceCheckCompleted: boolean,
  ): boolean {
    return userExistenceCheckCompleted;
  }

  @Selector([MemberSelectors._userExistenceStatus])
  static userExistenceStatus(
    userExistenceStatus: CheckUserExistsResult,
  ): CheckUserExistsResult {
    return userExistenceStatus;
  }

  @Selector([MemberState])
  private static _userExistenceStatus(
    state: MemberStateModel,
  ): CheckUserExistsResult {
    return state.userExistenceStatus;
  }

  @Selector([MemberState])
  private static _userExistenceCheckCompleted(
    state: MemberStateModel,
  ): boolean {
    return state.userExistenceCheckCompleted;
  }

  @Selector([MemberState])
  private static _userExistenceCheckError(state: MemberStateModel): string {
    return state.userExistenceCheckError ?? '';
  }

  @Selector([MemberState])
  private static _isCheckingUserExistence(state: MemberStateModel): boolean {
    return state.isCheckingUserExistence;
  }

  @Selector([MemberState])
  private static _userExists(state: MemberStateModel): boolean {
    return state.userExistenceStatus.isUserExist;
  }
}
